import React from 'react';
import classnames from 'classnames';
import DaysFromReleaseFilter from './DaysFromReleaseFilter';
import DropdownIndicator from './DropdownIndicator';
import MultiValueFilter from './MultiValueFilter';
import SingleDateFilter from './SingleDateFilter';
import DateRangeFilter from './DateRangeFilter';
import SingleValueFilter from './SingleValueFilter';
import MetricFilter from './MetricFilter';
import SegmentFilter from './SegmentFilter';
import SwitchButton from '../../SwitchButton';
import Toggle from './Toggle';

import { FilterType } from '../filter-types';

import { getOptionsLoader } from '../../../utils/filters';

import './styles/Filter.css';
import './styles/FilterMenu.css';
import { isEmpty } from 'lodash';

const Filter = ({
  hasChanged,
  id,
  isAsync,
  isDate,
  isFuture,
  isDisabled,
  isMetric,
  isMulti,
  isSegment,
  isSingleDate,
  isToggle,
  toggleOpts,
  toggleTooltip,
  hasBoolean,
  boolLayout,
  label,
  loadOptions,
  onChange,
  onChangeBooleanSeparator,
  onUpdateFilterOptions,
  options,
  value,
  selectedSegment,
  booleanSeparator,
  operators,
  title,
  className,
  isRequired,
  showInlineSelections,
  seasons,
  restrictedCategories,
  dataRectriction,
  allowBulk,
  bulkRequest,
  dates,
  isAliasMode,
  isValidDatesMode,
  rollupSupport,
  fieldState,
  disallowExcluded
}) => {
  const props = {
    className:
      className ||
      classnames('tvt-filter', { 'tvt-filter--changed': hasChanged }),
    classNamePrefix: allowBulk ? 'tvt-bulk-filter tvt-filter' : 'tvt-filter',
    components: { DropdownIndicator, IndicatorSeparator: null },
    hideSelectedOptions: false,
    isClearable: false,
    isSearchable: true,
    onChange: val => onChange(id, val),
    placeholder: label,
    id,
    isDisabled,
    value,
    selectedSegment,
    boolLayout,
    title,
    isToggle,
    isDate,
    isFuture,
    menuShouldScrollIntoView: true,
    dataRectriction,
    allowBulk,
    bulkRequest,
    dates,
    isAliasMode,
    isValidDatesMode,
    rollupSupport,
    fieldState,
    disallowExcluded
  };

  if (isAsync) {
    props.cacheOptions = false;
    props.defaultOptions = true;
    props.isAsync = true;
    if (id === 'episode') {
      props.seasons = seasons;
    }
    props.loadOptions = getOptionsLoader(
      id,
      onUpdateFilterOptions,
      loadOptions,
      restrictedCategories
    );
    props.options = options;
  } else {
    props.options = options;
  }

  if (isMetric) {
    props.operators = operators;
  }

  if (allowBulk) {
    props.noOptionsMessage = () => null;
  }

  const propsBoolean = {
    id,
    label: 'AND',
    labelRight: 'OR',
    checked: booleanSeparator,
    onChange: onChangeBooleanSeparator
  };

  if (isMulti && hasBoolean && boolLayout === 'inside') {
    props.components.BooleanSwitch = <SwitchButton {...propsBoolean} />;
  }

  const handleChange = val => {
    val = isEmpty(val) ? [] : val.filter(obj => obj.state !== 'empty');
    props.onChange(val);
  };

  switch (true) {
    case isToggle:
      return (
        <Toggle
          {...props}
          options={toggleOpts}
          onChange={onChange}
          tooltip={toggleTooltip}
        />
      );
    case isMulti:
      return (
        <MultiValueFilter
          {...props}
          onChange={handleChange}
          hasBoolean={hasBoolean}
          propsBoolean={propsBoolean}
          tooltip={toggleTooltip}
          showInlineSelections={showInlineSelections}
          isRequired={isRequired}
          disallowExcluded={disallowExcluded}
        />
      );
    case id === 'days_from_release':
      return <DaysFromReleaseFilter toggleChange={onChange} {...props} />;
    case isDate:
      return <DateRangeFilter toggleChange={onChange} {...props} />;
    case isSingleDate:
      return <SingleDateFilter {...props} />;
    case isMetric:
      return <MetricFilter {...props} />;
    case isSegment:
      return (
        <SegmentFilter
          {...props}
          onChange={handleChange}
          id={props.id}
          selectedSegment={selectedSegment}
          title={title}
          className={className}
        />
      );
    default:
      return <SingleValueFilter {...props} />;
  }
};

Filter.propTypes = FilterType;
Filter.defaultProps = {
  hasChanged: false,
  isAsync: false,
  isDate: false,
  isDisabled: false,
  isMetric: false,
  isMulti: false,
  isSingleDate: false,
  hasBoolean: false,
  loadOptions: () => {},
  onChange: () => {},
  onChangeBooleanSeparator: () => {},
  options: [],
  value: [],
  booleanSeparator: 'OR',
  boolLayout: 'inside',
  showInlineSelections: false,
  isRequired: false,
  restrictedCategories: []
};

export default Filter;
